import { isLocalhost } from "./isLocalhost";
const firebaseConfig = {
    apiKey: "AIzaSyBX0nT-_BfrlymlhvvRJtCd1HWc1tRWDAU",
    authDomain: "datadocs-front-end.firebaseapp.com",
    projectId: "datadocs-front-end",
    storageBucket: "datadocs-front-end.appspot.com",
    messagingSenderId: "364007121801",
    appId: "1:364007121801:web:fc7eccbc4180b338b6b758"
};
const firebaseLocalConfig = {
    apiKey: "AIzaSyDHsYRL6tR3YgoVObfQ9HcZ-BE_dkQBIMo",
    authDomain: "datadocs-front-end-dev.firebaseapp.com",
    projectId: "datadocs-front-end-dev",
    storageBucket: "datadocs-front-end-dev.appspot.com",
    messagingSenderId: "547168256198",
    appId: "1:547168256198:web:a34bd820f72cb5c29397c7"
};
export const firebaseEmulatorHost = "http://127.0.0.1:9099";
export function getFirebaseConfig() {
    return !isLocalhost ? firebaseConfig : firebaseLocalConfig;
}
